/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}         from '@/util/i.command';
import {DiversionEditor}  from './diversion.editor';
import {Train}            from '@/models/scenario/train';

/**
 *
 * @class SetTrainsCommand
 *
 * @brief reversible updates of the trains column
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class SetTrainsCommand implements ICommand {

  private oldValue: Train[];
  private newValue: Train[];
  private editor:   DiversionEditor;

  constructor(oldValue: Train[], newValue: Train[], editor: DiversionEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setTrains(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setTrains(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    return '[trains] ' + JSON.stringify(this.oldValue.map(x => x._name)) + ' => ' + JSON.stringify(this.newValue.map(x => x._name));
  }

}
